import { render, staticRenderFns } from "./ordered.vue?vue&type=template&id=71aa7d6b&scoped=true"
import script from "./ordered.vue?vue&type=script&lang=js"
export * from "./ordered.vue?vue&type=script&lang=js"
import style0 from "./ordered.vue?vue&type=style&index=0&id=71aa7d6b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71aa7d6b",
  null
  
)

export default component.exports